/**
 * Best Sellers — Quick Add to Cart
 * File: assets/custom-best-sellers.js
 */
(function () {
  'use strict';

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.custom-bestsellers__quick-add');
    if (!btn) return;

    const variantId = btn.dataset.productId;
    if (!variantId) return;

    // Loading state
    const originalHTML = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation:spin 0.6s linear infinite"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      // Success state
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.innerHTML = '✓ Added to Cart';

      // Dispatch cart update event for header cart count
      document.dispatchEvent(new CustomEvent('cart:updated'));

      setTimeout(() => {
        btn.classList.remove('is-success');
        btn.innerHTML = originalHTML;
      }, 2000);

    } catch (error) {
      btn.classList.remove('is-loading');
      btn.innerHTML = 'Error — Try Again';
      setTimeout(() => {
        btn.innerHTML = originalHTML;
      }, 2000);
    }
  });

  // Spin animation for loader
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

})();